import React from "react";

const EducationExpenseSummary = ({ payload, activeTabName }) => {
  const friendsAndFamilyKeys = [
    "Amount Received",
    "Friends and Family – Multiple Payment Amount",
    "Friends and Family – One-Time Payment Amount",
  ];

  const dedicatedSavingsKeys = [
    "Net Proceeds",
    "Amount Available to Assign",
    "Monthly Contribution Amount",
  ];

  const studentLoansKeys = ["Amount of Payment", "Student Loan Amount"];

  const scholarshipsKeys = ["Scholarship and Grant Amount"];

  const personalLoanKeys = ["Initial Loan Amount"];

  const workStudyKeys = ["Annual Work-Study Award Amount"];

  const educationDetailsKeys = ["Estimated Annual Cost of Attendance (Today's Dollars)", "Tuition and Fees", "Housing (Room)", "Meal Plan (Board)", "Books, Supplies, & Equipment", "Personal & Transportation Expenses"];

  const getSum = (keys) =>
    keys.reduce((acc, key) => {
      const val = payload[key] && parseFloat(payload[key]);
      return acc + (!isNaN(val) ? val : 0);
    }, 0);

  const formatCurrency = (amount) => {
    const num = Number(amount) || 0; // Ensure it's always a number
    return "$" + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const amountEducationDetailsSum = Number(getSum(educationDetailsKeys)) || 0;

  const amountReceivedFromFriendsAndFamilySum =
    Number(getSum(friendsAndFamilyKeys)) || 0;
  const amountDedicatedSavingsInvestmentsSum =
    Number(getSum(dedicatedSavingsKeys)) || 0;
  const amountStudentLoansSum = Number(getSum(studentLoansKeys)) || 0;
  const amountScholarshipsAndGrantsSum = Number(getSum(scholarshipsKeys)) || 0;
  const amountPersonalLoanHELOCSum = Number(getSum(personalLoanKeys)) || 0;
  const amountWorkStudySum = Number(getSum(workStudyKeys)) || 0;

  const totalNeed = amountEducationDetailsSum;

  const totalFunding =
    amountReceivedFromFriendsAndFamilySum +
    amountDedicatedSavingsInvestmentsSum +
    amountStudentLoansSum +
    amountScholarshipsAndGrantsSum +
    amountPersonalLoanHELOCSum +
    amountWorkStudySum;

  const remainingNeed = totalNeed - totalFunding;

  return (
    <div>
      {activeTabName &&
        [
          "GOAL DETAILS",
          "EDUCATION DETAILS",
          "ASSISTANCE FROM FRIENDS AND FAMILY",
          "DEDICATED SAVINGS & INVESTMENTS",
          "STUDENT LOANS",
          "SCHOLARSHIPS AND GRANTS",
          "PERSONAL LOAN / HELOC",
          "WORK STUDY",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay">
            <div>
              Education Details: {formatCurrency(amountEducationDetailsSum)}
            </div>
            <div>
              Assistance from Friends and Family:{" "}
              {formatCurrency(amountReceivedFromFriendsAndFamilySum)}
            </div>
            <div>
              Dedicated Savings & Investments:{" "}
              {formatCurrency(amountDedicatedSavingsInvestmentsSum)}
            </div>
            <div>
              Student Loans: {formatCurrency(amountStudentLoansSum)}
            </div>
            <div>
              Scholarships and Grants:{" "}
              {formatCurrency(amountScholarshipsAndGrantsSum)}
            </div>
            <div>
              Personal Loan / HELOC:{" "}
              {formatCurrency(amountPersonalLoanHELOCSum)}
            </div>
            <div>
              Work Study: {formatCurrency(amountWorkStudySum)}
            </div>
            <div style={{ marginTop: "10px" }}>
              <strong>
                Total Need: {formatCurrency(totalNeed)}
              </strong>
            </div>
            <div>
              <strong>
                Total Funding: {formatCurrency(totalFunding)}
              </strong>
            </div>
            <div>
              <strong>
                Remaining Need: {formatCurrency(remainingNeed > 0 ? remainingNeed : 0)}
              </strong>
            </div>
          </div>
        )}

    </div>
  );
};

export default EducationExpenseSummary;
